export { AddFeaturesSidebarSpotlight } from '../src/AddFeaturesSidebarSpotlight.tsx';
